module.exports = __webpack_public_path__ + "static/media/health-active.ef4497fd.svg";